<template>
  <div>
    <admin-sidebar></admin-sidebar>
    <section id="dashboard">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="title">
              <h2>Statistikat e klienteve</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="btn-dashboard">
              <button v-bind:class="{
                tablinks: true,
                active: requestType === '',
              }" @click="setRequestType('')">
                të gjitha
              </button>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="btn-dashboard">
              <button v-bind:class="{
                tablinks: true,
                active: requestType === 'annual',
              }" @click="setRequestType('annual')">
                vjetor
              </button>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="btn-dashboard">
              <button v-bind:class="{
                tablinks: true,
                active: requestType === 'seasonal',
              }" @click="setRequestType('seasonal')">
                sezonal
              </button>
            </div>
          </div>
        </div>
        <div class="w-100">
          <div class="d-block d-xl-flex">
            <div class="col-12 col-xl-3 flex-row m-md-0">
              <div class="row mb-xl-4">
                <ul class="management-btn">
                  <li>
                    <input type="search" placeholder="kerko" :value="searchQuery" @input="onChangeHandler"
                      v-on:keyup.enter="requestSearch" />
                    <button type @click="requestSearch">
                      <i class="fas fa-search"></i>
                    </button>
                  </li>
                </ul>
              </div>
              <div class="row">
                <input :checked="isFilterEnabled" class="search-checkbox" type="checkbox" @click="filter()">
                <label class="small pl-1">10 dite para skadimit te pakos.</label>
              </div>
            </div>
            <div class="row px-3 pl-xl-0">
              <table class="table table-bordered statistics-table table-responsive-xl">
                <thead>
                  <tr class="text-center">
                    <th class="px-xl-1">Klienta Aktiv</th>
                    <th class="px-xl-1">Pako Aktive</th>
                    <th class="px-xl-1">Kosova (vjetore)</th>
                    <th class="px-xl-1">Ballkani (vjetore)</th>
                    <th class="px-xl-1">Evropa (vjetore)</th>
                    <th class="px-xl-1">Personale (vjetore)</th>
                    <th class="px-xl-1">Kosova (sezonale)</th>
                    <th class="px-xl-1">Ballkani (sezonale)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!errors" class="text-center">
                    <td>{{ statistics.totalActiveUsers }}</td>
                    <td>{{ statistics.totalActivePackages }}</td>
                    <td>{{ statistics.kosovaAnnual }}</td>
                    <td>{{ statistics.ballkaniAnnual }}</td>
                    <td>{{ statistics.europaAnnual }}</td>
                    <td>{{ statistics.personaleAnnual }}</td>
                    <td>{{ statistics.kosovaSeasonal }}</td>
                    <td>{{ statistics.ballkaniSeasonal }}</td>
                  </tr>
                  <tr v-if="errors">
                    <td colspan="8" class="text-center text-danger">Ka ndodhur nje problem me statistikat ju lutem provoni
                      perseri!</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="white-background">
              <div class="tabcontent padding-0 tab-style tab-management">
                <table v-if="clients.length" class="table table-responsive-xl">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Emri dhe mbiemri</th>
                      <th>Pako e anëtarësimit</th>
                      <th>Numri total i intervenimeve</th>
                      <th>Numri total i kërkesave</th>
                      <th>Distanca e mbuluar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <router-link tag="tr" :to="{
                      name: 'admin/clients/detail',
                      params: { id: client.id },
                    }" v-for="client in client_statistics" :key="client.id"
                    :class="{ 'clients-list': !client.active_package}"
                      >
                      <th>{{ client.id }}</th>
                      <th>
                        {{ client.full_name }}
                      </th>
                      <th>{{client.active_package ? client.active_package.package_name : "Nuk ka pako aktive" }}</th>
                      <th>{{ client.interventions_number }}</th>
                      <th>{{ client.requests_number }}</th>
                      <th>{{ transformDistance(client.interventions_distance) }}</th>
                    </router-link>
                  </tbody>
                </table>
                <div v-else>Nuk u gjet asnje regjistrim!</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center align-items-center" v-if="clientsCount > perPageTotal">
          <div class="col-12">
            <div class="prev-next">
              <ul>
                <li v-if="currentPage > 1">
                  <button @click="getCurrentPage(currentPage - 1)">
                    <i class="fas fa-long-arrow-alt-left"></i>
                  </button>
                </li>
                <li v-if="currentPage > 3 && totalPages > 5">
                  <button>...</button>
                </li>
                <li v-for="pageNr in pageButtonsArray()" :key="pageNr">
                  <button v-if="pageNr !== currentPage" @click="getCurrentPage(pageNr)">
                    {{ pageNr }}
                  </button>
                  <button v-if="pageNr === currentPage" @click="getCurrentPage(pageNr)">
                    <strong>{{ pageNr }}</strong>
                  </button>
                </li>
                <li v-if="currentPage < totalPages - 2 && totalPages > 5">
                  <button>...</button>
                </li>
                <li v-if="currentPage !== totalPages">
                  <button @click="getCurrentPage(currentPage + 1)">
                    <i class="fas fa-long-arrow-alt-right"></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style src="@/assets/admin/css/main.css"></style>

<script>
import AdminSidebar from "@/components/admin/AdminSidebar";
import { mapGetters } from "vuex";
import moment from "moment";
import { transformDistance } from "@/utils";

export default {
  name: "AdminClients",
  components: {
    AdminSidebar: AdminSidebar,
  },
  data() {
    return {
      searchQueryTimeOut: null
    }
  },
  computed: {
    ...mapGetters({
      requestType: "clients/searchSeason",
      clients: "clients/clients",
      clientsCount: "clients/clientsCount",
      currentPage: "clients/currentPage",
      totalPages: "clients/totalPages",
      searchQuery: "clients/searchQuery",
      statistics: "clients/statistics",
      errors: "clients/errors",
      perPageTotal: "clients/perPageTotal",
      client_statistics: "clients/client_statistics",
    }),
    isFilterEnabled() {
      return this.$store.state.clients.is_filter_enabled;
    },
    isDriver() {
      return this.user().user_type === 'driver';
    }
  },
  methods: {
    transformDistance,
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY');
    },
    getCurrentPage(value) {
      this.$store.dispatch("clients/getCurrentPage", {
        value: value,
        route: this.$route,
        router: this.$router,
      });
    },
    range(start, stop, step) {
      if (typeof stop == "undefined") {
        stop = start;
        start = 0;
      }
      if (typeof step == "undefined") {
        step = 1;
      }
      if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
        return [];
      }
      var result = [];
      for (var i = start; step > 0 ? i < stop : i > stop; i += step) {
        result.push(i);
      }

      return result;
    },
    pageButtonsArray() {
      const { currentPage, totalPages, range } = this;
      let a = 0;
      let b = 0;

      if (totalPages < 6) {
        return range(1, totalPages + 1);
      }

      if (currentPage < 4) {
        a = 1;
        b = 5;
      } else if (totalPages - currentPage < 3) {
        a = totalPages - 4;
        b = totalPages;
      } else {
        a = currentPage - 2;
        b = currentPage + 2;
      }

      return range(a, b + 1);
    },
    filter() {
      this.$store.state.clients.is_filter_enabled = !this.$store.state.clients.is_filter_enabled;

      let date = moment().format('YYYY-MM-DD');

      if (this.$store.state.clients.is_filter_enabled) {
        this.$store.dispatch("clients/getSearchSeason", '');
        this.$store.dispatch("clients/getClientsTenDaysBeforePackageExpire", date);
        this.requestSearch();

      } else {
        this.$store.dispatch("clients/getClientsTenDaysBeforePackageExpire", '');
        this.requestSearch();
      }
    },
    setRequestType(value) {
      this.$store.state.clients.is_filter_enabled = false;
      this.$store.dispatch("clients/getClientsTenDaysBeforePackageExpire", '');
      this.$store.dispatch("clients/getSearchSeason", value);
      this.requestSearch();
    },
    getSearchQuery(e) {
      this.$store.state.clients.is_filter_enabled = false;
      this.$store.dispatch("clients/getClientsTenDaysBeforePackageExpire", '');
      this.$store.dispatch("clients/getSearchQuery", e.target.value);
    },
    requestSearch() {
      this.$store.dispatch("clients/requestSearch", {
        route: this.$route,
        router: this.$router,
      });
    },
    onChangeHandler(e) {
      clearTimeout(this.searchQueryTimeOut);

      this.getSearchQuery(e);

      this.searchQueryTimeOut = setTimeout(() => {
        this.requestSearch();
      }, 500);
    },
  },
  beforeMount() {
    this.getCurrentPage(1);
    this.$store.dispatch("clients/getClients");
    this.$store.dispatch("clients/getStatistics");
    this.$store.dispatch("clients/getClientsStatistics");
  },
};
</script>
